export default {
    THUMBNAIL: 'thumbnail', // WP size
    XS: 'XS', // 200h
    S: 'S', // 400h
    M: 'M', // 600h
    L: 'L', // 1000h
    XL:  'XL', // 1400h
    FULL: 'full', // WP size
};
